var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialX = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.486 6.775 15.303 0h-1.378l-5.05 5.883L4.84 0H.188l6.1 8.895L.188 16h1.378L6.9 9.788 11.16 16h4.652L9.486 6.775ZM7.598 8.974l-.618-.886L2.063 1.04H4.18l3.969 5.688.618.886 5.159 7.394h-2.118l-4.21-6.034Z",
  fill: "#2C4145"
})));
export default SvgSocialX;